import { render, staticRenderFns } from "./GlobalNav_.vue?vue&type=template&id=0ffcdbe3&scoped=true&"
import script from "./GlobalNav_.vue?vue&type=script&lang=js&"
export * from "./GlobalNav_.vue?vue&type=script&lang=js&"
import style0 from "./GlobalNav_.vue?vue&type=style&index=0&id=0ffcdbe3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffcdbe3",
  null
  
)

export default component.exports